import React, { Component } from 'react'


export default class NotFound extends Component {
  render() {
    return (
      <div className='NotFoundPage'>
        <h2>Page Not Found</h2>
        <p>This page doesn't exist, try going back or using the navigation menu</p>
      </div>
    )
  }
}